<statistics-has-sample-msg></statistics-has-sample-msg>
<page-header icon="fas fa-copy" [header]="'Documents with No Downloads' | translate" [subHeader]="'View data for the selected period.' | translate" [panelClass]="(domain | isStatsSampleData) ? 'mt-1' : ''">
    <page-header-content>
        <div class="row">
            <div class="col-48 d-flex align-items-center justify-content-end">
                <csv-export-button [monDisabled]="domain | isStatsSampleData" [exports]="exports"></csv-export-button>
                <date-picker [monEnableComparisonRange]="true"
                                 [(date)]="date"
                                 [monDateFormat]="dateFormat"
                                 [monValidateStartDateCb]="validateDate"
                                 [monValidateEndDateCb]="validateDate"
                                 (comparisonUpdate)="updateCompareDate($event)"
                                 (dateChange)="updateDateRange()">
                </date-picker>
                <table-search (getPage)="onSearch($event)"
                              [model]="search"
                              [minSearchLength]="3">
                </table-search>
            </div>
        </div>
    </page-header-content>
</page-header>
<div class="card panel-monsido-card">
    <div class="card-body">
        <div class="row outer-b-xlarge" *ngIf="loading">
            <div class="col-48 text-center">
                <span class="fas fa-spinner fa-spin fa-3x fa-fw" aria-hidden="true"></span>
            </div>
        </div>
        <div class="row" *ngIf="!loading">
            <div class="col-48">
                <table-container-pager
                        *ngIf="!comparisonEnabled"
                        [noResultMessage]="noDocumentsResultMsg"
                        [collection]="documents"
                        [page]="page"
                        (onPageChange)="onPageChangeLocal($event)"
                        (onPerPageChange)="onPageSizeChange($event)"
                        [pageSize]="pageSize"
                        [progress]="promise">
                    <table class="table table-hover table-fixed ">
                        <thead>
                            <tr>
                                <th class="col-sm-11 col-md-11" translate>URL</th>
                                <th class="col-sm-1 col-md-1 text-center" translate>Visits</th>
                            </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let document of documents">
                            <td class="text-ellipsis text-v-middle">
                                <statistics-url-title [title]="document.title" [url]="document.url"></statistics-url-title>
                            </td>
                            <td class="text-v-middle text-center">0</td>
                        </tr>
                        </tbody>
                    </table>
                </table-container-pager>
                <table-container-pager
                        *ngIf="comparisonEnabled"
                        [noResultMessage]="noDocumentsResultMsg"
                        [collection]="documents"
                        [page]="page"
                        (onPageChange)="onPageChangeLocal($event)"
                        [pageSize]="pageSize"
                        [progress]="promise"
                        class="table-pager-without-page-size">
                    <table class="table table-hover table-fixed ">
                        <thead>
                        <tr>
                            <th class="col-sm-11 col-md-11" translate>URL</th>
                            <th class="col-sm-1 col-md-1 text-center" translate>Visits</th>
                            <th  class="col-sm-1 col-md-1 text-right">
                                <span translate>Visits (comp.)</span>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let document of documents">
                            <td class="text-ellipsis text-v-middle">
                                <statistics-url-title [title]="document.title" [url]="document.url"></statistics-url-title>
                            </td>
                            <td class="text-v-middle text-center">0</td>
                            <td class="text-v-middle text-right table-comparison-cell">{{ document.compare?.downloads }}</td>
                        </tr>
                        </tbody>
                    </table>
                </table-container-pager>
            </div>
        </div>
    </div>
</div>